@if (SuppliedQueryData) {
  <div class="container-fluid">
    <div class="row row-padding">
      <div class="col">
        <h3>Unlink AP Vendors</h3>
      </div>
    </div>
    <div class="row row-padding vh-50">
      <div class="col">
        <app-ap-vendors-grid
          [gridName]="'UnlinkAPVendors'"
          [suppliedQueryData]="SuppliedQueryData"
          [rowSelectionType]="'multiple'"
          [selectedRowsPrimaryKeys]="SelectedApVendorIds"
        ></app-ap-vendors-grid>
      </div>
    </div>
    <div class="row row-padding">
      <div class="col">
        <button class="btn btn-danger h-100" (click)="close()">Cancel</button>
      </div>
      <div class="col">
        <button class="btn btn-primary h-100" (click)="continue()">
          Continue
        </button>
      </div>
    </div>
  </div>
}
